/* istanbul ignore file */

const fonts = {
  family: { text: "'Roboto', sans-serif", title: "'Blinker', sans-serif" },
};

export { fonts };
